import { createSlice } from '@reduxjs/toolkit';

const alertSlice = createSlice({
  name: 'alert',
  initialState: {
    alerts: [],
    selectedAlertId: '',
  },
  reducers: {
    addAlerts(state, action) {
      state.alerts = [...action.payload];
    },
    addAlertId(state, action) {
      state.selectedAlertId = action.payload;
    },
  },
});

export const { addAlerts, addAlertId } = alertSlice.actions;
export default alertSlice.reducer;
